module.exports = __webpack_public_path__ + "img/four1Red.370900a8.png";